interface ITransferIconProps {
  color?: string;
  className?: string;
}

const TransferIcon: React.FC<ITransferIconProps> = ({ color, className }) => (
  <svg
    viewBox="0 0 61 61"
    xmlns="http://www.w3.org/2000/svg"
    className={className}>
    <g style={{ fill: `${color || 'var(--tt-dark-purple)'}` }} fillRule="evenodd">
      <path d="M30.56.343v20.08H15.5l-7.53-5.02H2.95l10.04 12.55h45.18v-5.02l-7.53-2.51H40.6L35.58.343zM30.56 60.583v-20.08h15.06l7.53 5.02h5.02l-10.04-12.55H2.95v5.02l7.53 2.51h10.04l5.02 20.08z" />
    </g>
  </svg>
);

export default TransferIcon;
